<template>
  <v-dialog
    content-class="rx-login-form-dialog"
    v-model="open"
    scrollable
    persistent
    fullscreen
  >
    <rx-panel class="rounded-lg">
      <v-card-text class="d-flex pa-0">
        <rx-login-form
          isDialog
          @success="$emit('success', $event)"
        ></rx-login-form>
      </v-card-text>
    </rx-panel>
  </v-dialog>
</template>

<script>
import RxLoginForm from "@/redworks/components/auth/RxLoginForm";
import _ from "lodash";

export default {
  components: {
    RxLoginForm,
  },
  data() {
    return {
      open: true,
    };
  },
  created() {
    // 감지하여 로그인 폼 다이얼로그를 최상위로
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const target = mutation.target;
          if (target.classList.contains("v-dialog--active")) {
            const loginDialog = document.querySelector(
              "div.v-dialog__content.v-dialog__content--active:has(.rx-login-form-dialog)"
            );
            if (loginDialog) {
              const zIndexList = [];
              document
                .querySelectorAll(
                  "div.v-dialog__content.v-dialog__content--active:not(:has(.rx-login-form-dialog))"
                )
                .forEach((x) =>
                  zIndexList.push(
                    window.getComputedStyle(x).getPropertyValue("z-index")
                  )
                );
              const maxZIndex = _.max(zIndexList) || 0;

              const orgZIndex = window.getComputedStyle(loginDialog).getPropertyPriority("z-index");
              const newZIndex = Number(maxZIndex) + 1;
              if (!!orgZIndex && orgZIndex < newZIndex) {
                loginDialog.style.zIndex = newZIndex;
              }
            }
          }
        }
      });
    });

    observer.observe(document.getElementById("app"), {
      childList: true,
      subtree: true,
      attributeFilter: ["class"],
    });
    this.$once("hook:beforeDestroy", () => observer.disconnect());
  },
};
</script>

<style scoped>
::v-deep.v-main {
  padding: 0 !important;
}
</style>
